import { toast, ToastContainer } from "react-toastify";
import { Button, CheckBox, TextArea, SelectBox, Img, Input, Text, Heading } from "../../components";
import React, { useState } from "react";

const dropDownOptions = [
  { label: "Metal", value: "Metal" },
  { label: "Cement", value: "Cement" },
  { label: "Glass", value: "Glass" },
  { label: "Others", value: "Others" }
];

// function testToast() {
//   alert('Also this'); 
//   console.log('Testing toast fn');
//   toast.success("Yaaaayyy");
//   alert('And this'); 

// }

export default function ContactUsSection() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    industryType: "",
    message: "",
    terms: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Simple validation
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required.";
    if (!formData.lastName) newErrors.lastName = "Last Name is required.";
    if (!formData.email) newErrors.email = "Email is required.";
    if (!formData.company) newErrors.company = "Company name is required.";
    if (!formData.industryType) newErrors.industryType = "Industry Type is required.";
    if (!formData.message) newErrors.message = "Message is required.";
    if (!formData.terms) newErrors.terms = "You must agree to the terms and conditions.";
  
    setErrors(newErrors);
  
    // If there are no errors, proceed with form submission
    if (Object.keys(newErrors).length === 0) {
      try {
        const response = await fetch("/New-Zwilling-Website-PHP/send_contact_us_email.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            company: formData.company,
            industryType: formData.industryType,
            message: formData.message,
            terms: formData.terms ? "1" : "0",
          }),
        });
  
        const result = await response.json();
  
        if (result.status === "success") {
          toast.success(result.message)
          // Reset form after successful submission
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            company: "",
            industryType: "",
            message: "",
            terms: false,
          });
        } else {
          //alert(result.message);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("There was an error submitting the form. Please try again later.")
        //alert("There was an error submitting the form. Please try again later.");
      }
    }
  };

  return (
    <div className="mt-[70px] flex flex-col items-center md:px-10">
      <div className="container-xs flex flex-col items-center gap-[84px] px-14 md:gap-[63px] md:px-5 sm:gap-[42px]">
        <div className="mr-2.5 flex w-[76%] flex-col items-center gap-2.5 md:mr-0 md:w-full">
          <a href="#" className="md:text-[22px]">
            <Heading
              size="heading7xl"
              as="h1"
              className="text-[24px] font-bold uppercase tracking-[2.40px] text-amber-800_01"
            >
              Contact us
            </Heading>
          </a>
          <Heading
            as="h2"
            className="text-[46px] font-bold text-color_style-01_neutrals-grey800 md:text-[42px] sm:text-[36px]"
          >
            Twin with us!
          </Heading>
          <Text
            size="text11xl"
            as="p"
            className="self-stretch text-center text-[26px] font-normal leading-10 text-muted md:text-[24px] sm:text-[22px] sm:leading-6"
          >
            Want to upgrade your operations with cutting-edge digital solutions? We can help you, let’s connect!
          </Text>
        </div>
        <form onSubmit={handleSubmit} className="mr-2.5 flex w-[76%] flex-col gap-2.5 md:mr-0 md:w-full">
          <div className="flex flex-col sm:flex-row gap-2.5 md:flex-col">
            <Input
              size="sm"
              shape="round"
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="First name"
              className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
            />
            {errors.firstName && <p className="text-red-500 text-sm">{errors.firstName}</p>}
            <Input
              size="sm"
              shape="round"
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Last name"
              className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
            />
            {errors.lastName && <p className="text-red-500 text-sm">{errors.lastName}</p>}
          </div>
          <div className="flex flex-col sm:flex-row gap-2.5 md:flex-col">
            <Input
              size="sm"
              shape="round"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Id"
              className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
            />
            {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
            <Input
              size="sm"
              shape="round"
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Company name"
              className="w-full rounded-[12px] border-[1.58px] border-blue_gray-500_ad px-[18px]"
            />
            {errors.company && <p className="text-red-500 text-sm">{errors.company}</p>}
          </div>
          <SelectBox
            size="sm"
            shape="round"
            name="industryType"
            value={formData.industryType}
            onChange={handleChange}
            placeholder="Industry Type"
            options={dropDownOptions}
            className="gap-4 rounded-[12px] border-[1.58px] border-solid border-blue_gray-500_ad px-[18px] !text-muted sm:px-5"
          />
          {errors.industryType && <p className="text-red-500 text-sm">{errors.industryType}</p>}
          <TextArea
            size="sm"
            variant="tarOutlineBluegray500ad"
            shape="round"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            className="rounded-[18px] !border-[1.58px] !border-blue_gray-500_ad px-6 text-gray-600 sm:px-5"
          />
          {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
          <div className="flex items-center justify-between gap-5 sm:flex-col">
            <CheckBox
              name="terms"
              label="I agree to the terms and conditions"
              id="TermsCheckbox"
              checked={formData.terms}
              onChange={handleChange}
              className="gap-2.5 text-[18px] text-indigo-900_01"
            />
            {errors.terms && <p className="text-red-500 text-sm">{errors.terms}</p>}
            <Button
              size="6xl"
              type="submit"
              className="min-w-[194px] rounded-[14px] px-[34px] font-bold tracking-[-0.85px] sm:px-5"
            >
              Submit
            </Button>
            <ToastContainer position="top-right" />
          </div>
        </form>
      </div>
    </div>
  );
}
